import { DeletePolygonsModal } from './deletePolygonsModal';
export default DeletePolygonsModal;
